import React from 'react';
import { HexColorInput, HexAlphaColorPicker } from 'react-colorful';
import getFonts from '../../../Functions/config/fonts';
import getSelectField from '../../fields/select';
import toggleColorPicker from '../../../Functions/toggleColorPicker';

const FieldStyles = ({ widget, handleInputChange, setColorsAndPreview }) => {
    const { affordability } = widget.htmlData;
    const fontFamilyOptions = getFonts().map(font => ({ value: font, label: font }));

    // Ensure default values for font sizes to avoid empty inputs
    const fontSizeValue = affordability.fields.fontSize ? parseFloat(affordability.fields.fontSize) || 16 : 16;
    const labelFontSizeValue = affordability.fields.labelFontSize ? parseFloat(affordability.fields.labelFontSize) || 14 : 14;

    return (
        <div className="mjwi-acc-panel-wrapper">
            <div className="mjwi-row">
                <div className="mjwi-col50">
                    <label>Text Color</label>
                </div>
                <div className="mjwi-col66 mjwi-clr-picker">
                    <span
                        className="clrPickerVal"
                        style={{ backgroundColor: affordability.fields.textColor || '#333333' }}
                        onClick={toggleColorPicker}
                    ></span>
                    <HexAlphaColorPicker
                        color={affordability.fields.textColor || '#333333'}
                        onChange={(color) => setColorsAndPreview('fields', 'textColor', color)}
                        style={{ display: 'none' }}
                        className="mjwi-apfl-color-picker"
                    />
                    <HexColorInput
                        color={affordability.fields.textColor || '#333333'}
                        onChange={(color) => setColorsAndPreview('fields', 'textColor', color)}
                    />
                </div>
            </div>
            <div className="mjwi-row">
                <div className="mjwi-col50">
                    <label>Background Color</label>
                </div>
                <div className="mjwi-col66 mjwi-clr-picker">
                    <span
                        className="clrPickerVal"
                        style={{ backgroundColor: affordability.fields.bgColor || '#ffffff' }}
                        onClick={toggleColorPicker}
                    ></span>
                    <HexAlphaColorPicker
                        color={affordability.fields.bgColor || '#ffffff'}
                        onChange={(color) => setColorsAndPreview('fields', 'bgColor', color)}
                        style={{ display: 'none' }}
                        className="mjwi-apfl-color-picker"
                    />
                    <HexColorInput
                        color={affordability.fields.bgColor || '#ffffff'}
                        onChange={(color) => setColorsAndPreview('fields', 'bgColor', color)}
                    />
                </div>
            </div>
            <div className="mjwi-row">
                <div className="mjwi-col50">
                    <label>Label Font Weight</label>
                </div>
                <div className="mjwi-col50">
                    {getSelectField('labelFontWeight', ['normal', 'bold', '100', '200', '300', '400', '500', '600', '700', '800', '900'], affordability.fields.labelFontWeight || 'bold', (e) => handleInputChange(e, ['fields']))}
                </div>
            </div>
            <div className="mjwi-row">
                <div className="mjwi-col50">
                    <label>Text Align</label>
                </div>
                <div className="mjwi-col50">
                    {getSelectField('textAlign', ['left', 'center', 'right'], affordability.fields.textAlign || 'left', (e) => handleInputChange(e, ['fields']))}
                </div>
            </div>
            <div className="mjwi-row">
                <div className="mjwi-col50">
                    <label>Font Size</label>
                </div>
                <div className="mjwi-col50">
                    <div className="mjwi-size-input">
                        <input
                            type="number"
                            name="fontSize"
                            value={fontSizeValue}
                            onChange={(e) => handleInputChange({ target: { name: 'fontSize', value: `${e.target.value}px` } }, ['fields'])}
                            className="mjwi-input"
                            min="0"
                        />
                    </div>
                </div>
            </div>
            <div className="mjwi-row">
                <div className="mjwi-col50">
                    <label>Label Font Size</label>
                </div>
                <div className="mjwi-col50">
                    <div className="mjwi-size-input">
                        <input
                            type="number"
                            name="labelFontSize"
                            value={labelFontSizeValue}
                            onChange={(e) => handleInputChange({ target: { name: 'labelFontSize', value: `${e.target.value}px` } }, ['fields'])}
                            className="mjwi-input"
                            min="0"
                        />
                    </div>
                </div>
            </div>
            <div className="mjwi-row">
                <div className="mjwi-col50">
                    <label>Font Weight</label>
                </div>
                <div className="mjwi-col50">
                    {getSelectField('fontWeight', ['normal', 'bold', '100', '200', '300', '400', '500', '600', '700', '800', '900'], affordability.fields.fontWeight || 'normal', (e) => handleInputChange(e, ['fields']))}
                </div>
            </div>
            <div className="mjwi-row">
                <div className="mjwi-col50">
                    <label>Font Family</label>
                </div>
                <div className="mjwi-col50">
                    {getSelectField('fontFamily', fontFamilyOptions.map(opt => opt.label), affordability.fields.fontFamily || 'Arial, sans-serif', (e) => handleInputChange(e, ['fields']))}
                </div>
            </div>
        </div>
    );
};

export default FieldStyles;